import React from 'react';

// Confirmação no padrão do Saber (header branco), no lugar de window.confirm.
// Uso: <ConfirmarModal aberto={!!alvo} titulo="Excluir acesso" texto="..." perigo
//        rotuloConfirmar="Excluir" onConfirmar={...} onCancelar={() => setAlvo(null)} />
export default function ConfirmarModal({
  aberto, titulo, texto, perigo = false, rotuloConfirmar = 'Confirmar', processando = false,
  onConfirmar, onCancelar,
}) {
  if (!aberto) return null;
  return (
    <div className="modal show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,.45)', zIndex: 1080 }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content shadow-lg">
          <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
            <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
              <i className={`fas ${perigo ? 'fa-triangle-exclamation text-danger' : 'fa-circle-question'} me-2`}
                style={perigo ? undefined : { color: '#00b5cc' }}></i>{titulo}
            </h5>
            <button type="button" className="btn-close" onClick={onCancelar} disabled={processando}></button>
          </div>
          <div className="modal-body">{texto}</div>
          <div className="modal-footer bg-light">
            <button className="btn btn-secondary me-auto" onClick={onCancelar} disabled={processando}>
              <i className="fas fa-times me-2"></i>Cancelar
            </button>
            <button className={`btn ${perigo ? 'btn-danger' : 'btn-primary'}`} onClick={onConfirmar} disabled={processando}>
              <i className={`fas ${processando ? 'fa-spinner fa-spin' : 'fa-check'} me-2`}></i>{rotuloConfirmar}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
